import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer aria-label="Site footer" className="editorial-container pb-12 pt-0">
      <hr className="editorial-rule mb-8" />

      <div className="flex flex-col gap-6 sm:gap-4">
        {/* Site links */}
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-small text-foreground-faint">
          <Link to="/discovery-sprint" className="transition-colors duration-200 hover:text-accent">Discovery Sprint</Link>
          <Link to="/build-launch" className="transition-colors duration-200 hover:text-accent">Build &amp; Launch</Link>
          <Link to="/ai-systems" className="transition-colors duration-200 hover:text-accent">AI Systems</Link>
          <Link to="/about" className="transition-colors duration-200 hover:text-accent">About</Link>
          <Link to="/case-studies" className="transition-colors duration-200 hover:text-accent">Case Studies</Link>
          <Link to="/blog" className="transition-colors duration-200 hover:text-accent">Blog</Link>
        </div>

        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-small text-foreground-muted">
            &copy; {new Date().getFullYear()} Rick Deacon. Zero to Ten.
          </p>

          <div className="flex items-center gap-6 text-small text-foreground-faint">
            <span>Cleveland, OH</span>
            <a
              href="https://www.linkedin.com/in/rickdeaconx"
              target="_blank"
              rel="noopener noreferrer"
              className="text-foreground-muted transition-colors duration-200 hover:text-accent"
            >
              LinkedIn
            </a>
            <a
              href="https://x.com/rickdeaconx"
              target="_blank"
              rel="noopener noreferrer"
              className="text-foreground-muted transition-colors duration-200 hover:text-accent"
            >
              X
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
